<div class="w-100">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <div class="special-pricing-table-container z-3">
    <ag-grid-angular class="ag-theme-alpine" rowSelection="multiple" rowMultiSelectWithClick="false" rowHeight="48" suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true" suppressMenuHide="true" enableCellTextSelection="true" detailRowAutoHeight="true" [alwaysShowVerticalScroll]="true"
      [icons]="customIcons" [masterDetail]="true" [detailCellRenderer]="specialSubtable" [columnDefs]="columnDefs" [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef" [paginationPageSize]="paginationPageSize" [pagination]="true" [suppressPaginationPanel]="true"
      [suppressCellSelection]="true" [suppressContextMenu]="true" [getMainMenuItems]="getMainMenuItems" [suppressScrollOnNewData]="true" [rowData]="rowData"
      [domLayout]="domLayout" (columnMoved)="onColumnMoved($event)" (columnResized)="onColumnResized($event)" (columnVisible)="onColumnVisible($event)"
      (sortChanged)="onSortChange($event)" (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination *ngIf="totalRowsCount > paginationPageSize" [totalItems]="totalRowsCount" [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)" [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count">Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize  : totalRowsCount }} of {{ totalRowsCount }}
        results</span>
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>


<ng-template #customersModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Customers ({{currentRow.users?.length}})</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="currentRow.users.length" class="pills-holder mt-0_5 mb-20">
      <div *ngFor="let user of currentRow.users; let i = index;" class="pills-btn">
        <span class="text-neutral-n9"> {{ user.email }}</span>
      </div>
    </div>
  </div>
</ng-template>
